/* Initial onboarding ONLY. Never overwrites nonempty onboarding fields or saved profile choices. */
(() => {
  'use strict';
  const normalize = s => String(s ?? '').toLowerCase().replace(/[^a-z0-9]+/g,'');
  const answers = value => Array.isArray(value) ? value.map(x=>String(x ?? '').trim()).filter(Boolean) : [];

  function selectMatching(container, list, custom) {
    if (!container || !list.length) return;
    const options = [...container.querySelectorAll('input[type="checkbox"]')];
    if (options.some(o=>o.checked)) return; // Always preserve mentor's own selections.
    const other = options.find(o=>o.dataset.choiceOther === 'true');
    const unknown = [];
    for (const text of list) {
      const label = normalize(text);
      const matched = options.find(o=>normalize(o.closest('label')?.querySelector('span')?.textContent)===label);
      if (matched && !matched.checked) {
        matched.checked = true;
        matched.dispatchEvent(new Event('change',{bubbles:true}));
      } else if (!matched) unknown.push(text);
    }
    if (unknown.length && other && !other.checked) {
      other.checked = true;
      other.dispatchEvent(new Event('change',{bubbles:true}));
    }
    if (unknown.length && other && custom && !custom.value.trim()) custom.value = unknown.join(', ').slice(0,160);
  }

  async function apply({form,expertiseContainer,languagesContainer,mentor}) {
    if (!form || mentor?.onboarding_completed) return;
    const db = window.PeerNestDB;
    if (!db?.getMyMentorApplication) return;
    const app = await db.getMyMentorApplication();
    if (!app) return;
    const assign = (field,value) => {
      const node=form.elements.namedItem(field);
      if (node && !String(node.value || '').trim() && value !== null && value !== undefined) node.value=String(value);
    };
    assign('graduation_year',app.graduation_year);
    assign('linkedin_url',app.linkedin_url);
    // Do not reuse application photo_url as public mentor photo: onboarding validates
    // ownership of a different storage bucket/path. The mentor chooses a photo here.
    const achievements = answers(app.achievements_text);
    if (achievements.length) assign('achievements',achievements.join('\n'));
    selectMatching(expertiseContainer,answers(app.expertise_text),form.elements.namedItem('custom_expertise_text'));
    selectMatching(languagesContainer,answers(app.languages_text),form.elements.namedItem('custom_language_text'));
    // The existing application schema has NO location column. Location remains editable.
  }
  window.PeerNestMentorAppPrefill = Object.freeze({apply});
})();
